module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Styles-fc5c8dca4fe279f0d9123f625a70aefe.png";